import React, { useState, useEffect, useRef, createContext } from "react";

const CpeContext = createContext();

export const CpeConsumer = CpeContext.Consumer;

const CpeProvider = (props) => {
  const [cpe, setCpe] = useState([]);

  return (
    <CpeContext.Provider
      value={{
        cpe,
        setCpe,
      }}
    >
      {props.children}
    </CpeContext.Provider>
  );
};

export default CpeContext;

export { CpeProvider, CpeContext };
